import { Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MachineListDto } from '../../models/machines/machine-list-dto';
import { MachineListFilter } from '../../models/machines/machine-list-filter';
import { MachineApiService } from '../api/machine-api.service';

@Injectable({
  providedIn: 'root'
})
export class MachineListService {
  private dataSubject = new BehaviorSubject<MachineListDto[] | null>(null);
  data$ = this.dataSubject;

  constructor(private machineApiService: MachineApiService) {
  }

  @Output() filterChange = new BehaviorSubject<MachineListFilter>({
    search: [],
    machineType: [],
    productionTechnicianArea: [],
    productionLeader: [],
    ownerType: [],
    hasHighPrecisionCraneTipCoordinate: [],
    hasRtk: [],
    isSchoolForwarder: [],
    isGrotForwarder: [],
    isDemoMachine: [],
    status: []
  });

  loadMachines() {
    this.machineApiService.getMachineList().subscribe(data => {
      this.dataSubject.next(data)
    });
  }

  applyFilter(filterValues: MachineListFilter | undefined) {
    filterValues ? this.filterChange.next(filterValues) : console.log('no filter found');
  }
}
